import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useUserProfile } from '../hooks/useUserProfile';
import './Nav.css';
import navIcon from '../assets/nav-icon.svg';

const Nav = () => {
  const { currentUser } = useAuth();
  const { profile: userProfile } = useUserProfile(currentUser?.uid);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const photoUrl = userProfile?.profileImage || null;
  const firstName = userProfile?.firstName || '';
  const fallbackInitial = firstName
    ? firstName.charAt(0).toUpperCase()
    : currentUser?.email?.charAt(0).toUpperCase() || 'U';

  const handleProfileClick = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <>
      <header className="site-header">
        <Link to={currentUser ? "/feed" : "/signup"} className="header-logo-link">
          <span className="header-logo-text"><span className="text-dark">Sat</span><span className="text-light">Sat</span></span>
          <img src={navIcon} alt="" className="header-logo-icon" />
        </Link>
        <nav className="site-nav">
          <Link to="/about">About</Link>
          <Link to="/invite">Invite Friends</Link>
          {!currentUser && <Link to="/signup">Sign in</Link>}
          {currentUser && <Link to="/feed">Find a Table</Link>}
          {currentUser && (
            <button className="nav-profile-button" onClick={handleProfileClick}>
              {photoUrl ? (
                <img src={photoUrl} alt="Profile" className="nav-profile-avatar" />
              ) : (
                <div className="nav-profile-avatar nav-profile-avatar--placeholder">
                  {fallbackInitial}
                </div>
              )}
            </button>
          )}
        </nav>
      </header>

      {sidebarOpen && (
        <>
          <div className="sidebar-overlay" onClick={closeSidebar} />
          <aside className="sidebar">
            <button className="sidebar-close" onClick={closeSidebar}>
              &times;
            </button>
            <nav className="sidebar-nav">
              <Link to="/profile" onClick={closeSidebar}>
                Profile
              </Link>
              <Link to="/reservations" onClick={closeSidebar}>
                Reservations
              </Link>
              <Link to="/host-dashboard" onClick={closeSidebar}>
                Host a Meal
              </Link>
              <div className="sidebar-nav-divider" />
              <Link to="/meals-attended" onClick={closeSidebar} className="sidebar-nav-history">
                Meals Attended
              </Link>
              <Link to="/meals-hosted" onClick={closeSidebar} className="sidebar-nav-history">
                Meals Hosted
              </Link>
              <Link to="/reviews" onClick={closeSidebar} className="sidebar-nav-history">
                Review History
              </Link>
            </nav>
          </aside>
        </>
      )}
    </>
  );
};

export default Nav;
